import { PushGADataLayer } from "../../utils/helpers";
import BaseButton from "../BaseButton";
import IconComponent from "../icons";
import React, {useState} from 'react';

const OVERVIEW = "Overview"; 

const backButtonAction = (nav, setAction, setPanel,setMainNav) => {
    setAction(nav[0]); 
    setPanel({innerNavTitle:''});
    setMainNav(true)
}

const getNavHeader = (nav,currentAction,setAction, setPanel, isMainNav, setMainNav)=> {
    const backClick = () => {backButtonAction(nav, setAction, setPanel, setMainNav)}
    if(!isMainNav){
        return (
            <div className="border-b-[0.5px] ek-grey-200 grid grid-cols-12">
                <div className='relative'>
                    <BaseButton btnClick={backClick} iconleft={true} icon='chevron-left' type='tertiary' classes='absolute border-0 font-bold text-center w-min ml-4' title='BACK' size="none" iconClassName='mt-4'/>
                </div>
                <div className="col-span-12 p-[10px] pr-4 font-bold text-center">{currentAction.title}</div>
            </div>
        )
    }
}

const getNavPanel = (panelData, innerNavTemplate, innerNavTitle) => {
    return(<div className="bg-ek-grey-light col-span-12">
        {panelData.length>0 && <a href={innerNavTemplate}  rel="noreferrer" onClick={() => PushGADataLayer('Navigations','Top Navigation',innerNavTitle)}><div className="border-b-[0.5px] border-ek-grey-200 col-span-10 px-[36px] py-[11px] text-ek-grey-500 text-xs leading-[18px]">{OVERVIEW}</div></a>}
    {panelData.map((panel) => <a href={panel.innerNavSubTemplate} target={panel.innerNavSubTarget ? "_blank" : panel.innerNavSubTarget}  rel="noreferrer" onClick={() => PushGADataLayer('Navigations','Top Navigation',panel.innerNavSubTitle)}><div className="border-b-[0.5px]  border-ek-grey-200 col-span-10 px-[36px] py-[11px] text-ek-grey-500 text-xs leading-[18px]">{panel.innerNavSubTitle}</div></a>)}
    </div>)
}

const setPanelAction = (panel, element, setPanel) =>{
    if(panel.innerNavTitle!== element.innerNavTitle){
        setPanel(element);
        if(element.innerNavItems.length===0) {
            PushGADataLayer('Navigations','Top Navigation', element.innerNavTitle === OVERVIEW ? element.title : element.innerNavTitle); 
            window.location.href = element.innerNavTemplate;
        }
    } else {
        setPanel({innerNavTitle:''})
    }
}

const unsetMainPanelAction = (setAction,el,setMainNav) => {
    setAction(el);
    setMainNav(false);
}

const getNavChildren = (nav, currentAction, setAction, panel, setPanel, isMainNav, setMainNav) =>{
    let childNav = [];
    const ctaAction = nav[0].ctaaction;
    if(isMainNav){
        for(const el of  nav) {
            if(Array.isArray(el.data)){
                childNav.push(
                <a key={el.title} className="border-b-[0.5px] ek-grey-200 grid grid-cols-12" href={el.href} target={el.target} onClick={() => PushGADataLayer('Navigations','Top Navigation',el.title)}>
                    <div  className={`col-span-1 ${el.active?'border-l-ek-red border-y-inherit border-l-[5px]':''}`}></div>
                    <div className="col-span-10 p-[10px] pr-4 -ml-6 md:-ml-14 ">{el.title}</div>
                </a>
                )
            }else {
            childNav.push(
            <div key={el.title} className="border-b-[0.5px] ek-grey-200 grid grid-cols-12" onClick={()=> unsetMainPanelAction(setAction,el,setMainNav)}>
                <div  className={`col-span-1 ${el.active?'border-l-ek-red border-y-inherit border-l-[5px]':''}`}></div>
                <div className="col-span-10 p-[10px] pr-4 -ml-6 md:-ml-14 ">{el.title}</div>
                <div className="col-span-1 inline p-[10px] pr-4">
                    <IconComponent icon='chevron-right' className='mt-2'/>
                </div>
            </div>)
            }
        }
        childNav.push(<>
            <div className="col-span-12 px-4 py-4 text-base font-bold text-start">{ctaAction.sideNavigationTitle}</div>
            {
            ctaAction.sideNavigations.map((sideNavigation)=>{
            return(<a href={sideNavigation.sideNavigationChildURL} target={sideNavigation.sideNavigationChildTarget} onClick={() => PushGADataLayer('Navigations','Top Navigation',sideNavigation.sideNavigationChildTitle)}>
                <div className={`border-b-[0.5px] ek-grey-200 ${sideNavigation.sideNavigationChildTarget?'grid':''} grid-cols-12`}>
                    <div className="capitalize text-sm col-span-10 p-[10px] pl-4">{sideNavigation.sideNavigationChildTitle.toLowerCase()}</div>
                    {sideNavigation.sideNavigationChildTarget?
                    <div className="col-span-2 inline p-[10px] pl-[40px] md:pl-[70px]">
                        <IconComponent icon='external-link' className='w-3 h-3 ek-neutral-grey-500' />
                    </div> :null  
                    }
                </div>
            </a>)
            })}
            <div className="mx-[10px]">
                    <BaseButton icon={ctaAction.sideNavigationsCTA[0].sideNavigationChildIcon} type='primary' classes='font-bold mt-6 w-full' iconClassName="ml-1.5 -mt-0.5 w-5" title={ctaAction.sideNavigationsCTA[0].sideNavigationChildTitle} href={ctaAction.sideNavigationsCTA[0].sideNavigationChildURL} target='_blank' btnClick={()=>{PushGADataLayer('Navigations','Top Navigation',ctaAction.sideNavigationsCTA[0].sideNavigationChildTitle)}}/>
                    <BaseButton icon={ctaAction.sideNavigationsCTA[1].sideNavigationChildIcon} type='secondary' classes='font-bold mt-4 w-full' iconClassName="ml-1.5 -mt-0.5 w-5" title={ctaAction.sideNavigationsCTA[1].sideNavigationChildTitle} href={ctaAction.sideNavigationsCTA[0].sideNavigationChildURL} target='_blank' btnClick={()=>{PushGADataLayer('Navigations','Top Navigation',ctaAction.sideNavigationsCTA[1].sideNavigationChildTitle)}}/>
            </div> 
            </>)
    } else {
        let navItems = [{
            title: currentAction.title,
            innerNavTitle: OVERVIEW,
            innerNavTemplate: currentAction.href,
            innerNavItems: []
        }];
        navItems = [...navItems, ...currentAction.data['em-nav-item']]
        for(const el of  navItems) {
            childNav.push(
            el.innerNavTemplate &&
            <div key={el.innerNavTitle} className="border-b-[0.5px] ek-grey-200 grid grid-cols-12" onClick={()=>setPanelAction(panel, el, setPanel)}>
                <div className={`col-span-1 border-l-ek-red border-y-inherit ${(el.innerNavTitle === panel.innerNavTitle)?'border-l-[5px]':''}`}></div>
                <div className={`col-span-10 p-[10px] pr-4 -ml-6 md:-ml-14  ${(el.innerNavTitle === panel.innerNavTitle)?'font-bold':''}`}>{el.innerNavTitle}</div>
                <div className="col-span-1 inline p-[10px] pr-4">
                    {(el.innerNavItems.length && (el.innerNavTitle !== panel.innerNavTitle))?<IconComponent icon='chevron-down'  className='mt-2'/>:null}
                    {(el.innerNavItems.length && (el.innerNavTitle === panel.innerNavTitle))?<IconComponent icon='chevron-up'  className='mt-2'/>:null}
                </div>
                {panel && el.innerNavTitle === panel.innerNavTitle?getNavPanel(el.innerNavItems, el.innerNavTemplate, el.innerNavTitle):null}
            </div>)
        }
    }
    return childNav;
}

const MobileNav =({nav,action})=>{

    const [currentAction, setAction] = useState(()=>nav[0]);
    const [isMainNav, setMainNav] = useState(true);
    const [panel, setPanel] =useState({innerNavTitle:''});

    if(!nav && !action){
        return null;
    }
    return(
        <aside className="pt-12 h-[calc(100vh-44px)] w-screen bg-white z-40 absolute flex flex-col text-black justify-start items-stretch justify-items-stretch overflow-auto">
            <BaseButton key={action[0].href} href={action[0].href} target={action[0].target} icon={action[0].icon} type='tertiary' classes='absolute right-1 top-1 border-0 font-bold text-right w-min mr-3' title={action[0].title} size="none" iconClassName='w-5 h-5' btnClick={()=>{PushGADataLayer('Navigations','Top Navigation',action[0].title)}}/>
            {getNavHeader(nav,currentAction, setAction,setPanel, isMainNav, setMainNav)}
            {getNavChildren(nav, currentAction, setAction, panel, setPanel, isMainNav, setMainNav)}
        </aside>

    )
}

export default MobileNav;